import React from 'react';

import OLVectorLayer from 'ol/layer/Vector';

import Layer from './Layer';

const VectorLayer = config => <Layer {...config} LayerType={OLVectorLayer} />;

export default VectorLayer;
